import App from 'components/RegistrationApp';
import { I18nProvider, I18nRerenderBoundary } from 'contexts/I18n/I18nContext';
import { TranslateProvider } from 'contexts/Translate/TranslateContext';
import { withRouter } from 'hooks/useRouter';
import ErrorBoundary from 'modules/ErrorBoundary/ErrorBoundary';
import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import routes from 'routes';
import BiometricProvider from '../../contexts/Biometric';
import ThemeProvider from '../../contexts/Theme';

const MainApp = props => {
  const { history, location } = props;
  const renderRouter = routes => {
    let result = null;
    if (routes.length > 0) {
      result = routes.map((route, index) => {
        const { path, exact, component: Component, name } = route;
        return (
          <Route
            key={index}
            path={path}
            exact={exact}
            element={
              <ErrorBoundary pageName={`${name} - path: ${path}`}>
                <Suspense fallback={<div style={{ minHeight: '100vh', width: '100vw' }} />}>
                  <Component history={history} location={location} />
                </Suspense>
              </ErrorBoundary>
            }>
            {/* {route.routes &&
              route.routes.length > 0 &&
              route.routes.map((sub, subIdx) => {
                const { component: SubComponent, name, path } = sub;
                return (
                  <Route
                    key={`sub-${subIdx}`}
                    path={sub.path}
                    exact={sub.exact}
                    element={
                      <ErrorBoundary pageName={`${name} - path: ${path}`}>
                        <SubComponent history={history} location={location} />
                      </ErrorBoundary>
                    }>
                    {sub.routes &&
                      sub.routes.length > 0 &&
                      sub.routes.map((child, childIdx) => {
                        const { component: ChildComponent, name, path } = child;

                        return (
                          <Route
                            key={`sub-child-${childIdx}`}
                            path={child.path}
                            exact={child.exact}
                            element={
                              <ErrorBoundary pageName={`${name} - path: ${path}`}>
                                <ChildComponent history={history} location={location} />
                              </ErrorBoundary>
                            }
                          />
                        );
                      })}
                  </Route>
                );
              })} */}
          </Route>
        );
      });
    }
    return <Routes>{result}</Routes>;
  };

  return (
    <ErrorBoundary isRoot pageName="Root">
      <ThemeProvider>
        <I18nProvider>
          <TranslateProvider>
            <BiometricProvider>
              <I18nRerenderBoundary>{() => <App routes={routes}>{renderRouter(routes)}</App>}</I18nRerenderBoundary>
            </BiometricProvider>
          </TranslateProvider>
        </I18nProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default withRouter(MainApp);
